import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WeeklyConsolPlanningFormComponent } from './weekly-consol-planning-form/weekly-consol-planning-form.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: "Weekly Consol Planning"
    },
    component: WeeklyConsolPlanningFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WeeklyConsolPlanningRoutingModule { }
